import ModalStep from '../enums/modalStep';
import DateTimeForm from '../components/dateTimeForm';
import SpecSelection from '../components/specSelection';
import TourBookingGuide from '../components/tourBookingGuide';
import TourConfiguration from '../components/tourConfiguration';
import TourSummary from '../components/tourSummary';
import TermsAndConditions from '../components/termsAndConditions';
import Confirmation from '../components/confirmation';
import Questions from '../components/questions';
import SignIn from '../components/signIn';
import SignUp from '../components/signUp';
import PhoneVerification from '../components/phoneVerification';
import IdentityVerification from '../components/identityVerification';
import CreditCardVerification from '../components/creditCardVerification';
import IframeVerification from '../components/iframeVerification';
import VerificationInProgress from '../components/verificationInProgress';

const mainComponents = {
  [ModalStep.SpecSelection]: SpecSelection,
  [ModalStep.DateTimeSelection]: DateTimeForm,
  [ModalStep.TourConfiguration]: TourConfiguration,
  [ModalStep.TermsAndConditions]: TermsAndConditions,
  [ModalStep.Questions]: Questions,
  [ModalStep.Confirmation]: Confirmation,
  [ModalStep.SignIn]: SignIn,
  [ModalStep.SignUp]: SignUp,
  [ModalStep.PhoneVerification]: PhoneVerification,
  [ModalStep.IdentityVerification]: IdentityVerification,
  [ModalStep.CreditCardVerification]: CreditCardVerification,
  [ModalStep.IframeVerification]: IframeVerification,
  [ModalStep.VerificationInProgress]: VerificationInProgress,
};

const complementaryComponents = {
  [ModalStep.SpecSelection]: TourBookingGuide,
  [ModalStep.DateTimeSelection]: TourBookingGuide,
  [ModalStep.TourConfiguration]: TourSummary,
  [ModalStep.TermsAndConditions]: TourSummary,
  [ModalStep.Questions]: TourSummary,
  [ModalStep.Confirmation]: TourSummary,
  [ModalStep.SignIn]: TourSummary,
  [ModalStep.SignUp]: TourSummary,
  [ModalStep.PhoneVerification]: TourSummary,
  [ModalStep.IdentityVerification]: TourSummary,
  [ModalStep.CreditCardVerification]: TourSummary,
  [ModalStep.IframeVerification]: TourSummary,
  [ModalStep.VerificationInProgress]: TourSummary,
};

const mainComponentReg = new Map();
const complementaryComponentReg = new Map();

export default (modalStep, paneType, rootComponent) => {
  const registry = paneType === 'main' ? mainComponentReg : complementaryComponentReg;
  const instance = registry.get(modalStep);

  if (instance) {
    return instance;
  }

  const ComponentClass = paneType === 'main' ? mainComponents[modalStep] : complementaryComponents[modalStep];
  if (!ComponentClass) {
    return null;
  }

  const newInstance = new ComponentClass(rootComponent);
  registry.set(modalStep, newInstance);
  return newInstance;
};
